<div class="container">
    <div class='bread-crumb'>
        <h2 class='bread-crumb-title'>Bookings</h2>
        <p><small>resources/bookings</small></p>
        <hr class='bread-crumb-divider'>
    </div>
</div>